export const STORAGE_KEYS = {
  token: 'token',
  refreshToken: 'refreshToken',
  meInfo: 'meInfo',

  // （加分用，之後做 token 到期判斷）
  tokenExpiresAt: 'tokenExpiresAt',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
